import { catchError, from, map, Observable, take, throwError } from "rxjs";
import { hubPublish } from "src/app/core/hub/hub";
import { HubChannels } from "src/app/core/hub/hub-channels";
import { HubEvent } from "src/app/core/hub/hub-events";
import { isPromise } from "src/app/support/promise";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("EventDecorator");
type EventOptions = {
  dataFactory?: (args: any[], response: any) => any;
};

export function Event(event: HubEvent, options: EventOptions) {
  return function (
    target: Object,
    key: string | symbol,
    descriptor: PropertyDescriptor
  ) {
    const originalValue: (...args: any[]) => Observable<any> = descriptor.value;

    descriptor.value = function (...args: any[]) {
      let originalObs: Observable<any> | Promise<any> = originalValue.apply(
        this,
        args
      );

      const wasPromise = isPromise(<Promise<any>>(<any>originalObs));

      if (wasPromise) {
        originalObs = from(originalObs);
      }

      const piped = originalObs.pipe(
        map((data) => {
          hubPublish(HubChannels.EVENTS, {
            event,
            data: options.dataFactory ? options.dataFactory(args, data) : args
          });

          return data;
        }),
        catchError((error) => {
          logger.error(error);
          return throwError(() => error);
        })
      );

      if (wasPromise) {
        piped.pipe(take(1)).subscribe();
      }

      return piped;
    };

    return descriptor;
  };
}
